<div id="consulta" class="mb-1">
    <fieldset class="panel">
        <legend>Consultas Realizadas</legend>
        <div class="table-responsive">
        <table class="table table-sm table-striped table-hover">
            <thead>
              <tr>
                <th scope="col">Data</th>
                <th scope="col">Horário</th>
                <th scope="col">Status</th>
                <th scope="col">Especialidade</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let marcacao of marcacoes" (click)="setMarcacaoAtual(marcacao)"
                  [class.table-active]="marcacao.seq_Agenda == marcacaoAtual?.seq_Agenda">
                <td>{{ marcacao.data_Agenda | date: 'dd/MM/yyyy' }}{{ marcacao.seq_Agenda == marcacaoAtual?.seq_Agenda ? "*" : ""}}</td>
                <td>{{ marcacao.hora_Agenda | numeroParaHora }}</td>
                <td>{{ marcacao.status }}</td>
                <td>{{ marcacao.corpoClinico?.setoresClinica?.descricao_Clinica }}</td>
              </tr>
            </tbody>
          </table>
          </div>
    </fieldset>
</div>
